export type CreditsLine = {
  actionDefinitionId: string;
  actionDefinitionName: string;
  credits: number;
};

export type CreditsGroup = {
  actionDefinitionId: string;
  actionDefinitionName: string;
  executionCount: number;
  credits: number;
};

const MIN_SHOWN_CREDITS = 0.001;

const creditsFormat = new Intl.NumberFormat('en-US', {
  maximumFractionDigits: 3,
});

export function formatCredits(credits: number): string {
  if (credits > 0 && credits < MIN_SHOWN_CREDITS) {
    return `<${creditsFormat.format(MIN_SHOWN_CREDITS)}`;
  }
  return creditsFormat.format(credits);
}

export function groupCreditsBySop(lines: CreditsLine[]): CreditsGroup[] {
  const groups = new Map<string, CreditsGroup>();
  for (const { actionDefinitionId, actionDefinitionName, credits } of lines) {
    const group = groups.get(actionDefinitionId) ?? {
      actionDefinitionId,
      actionDefinitionName,
      executionCount: 0,
      credits: 0,
    };
    group.executionCount += 1;
    group.credits += credits;
    groups.set(actionDefinitionId, group);
  }
  return Array.from(groups.values()).sort((a, b) => b.credits - a.credits);
}
